import { createFileRoute } from "@tanstack/react-router";
import { generateSeo } from "@/lib/utils/seo";

export const Route = createFileRoute("/_main/about")({
	head: () =>
		generateSeo({
			title: "About CraftLayer | Top Web & Marketing Team in Bangalore",
			description:
				"Learn about CraftLayer, Bangalore's premier digital agency. We combine creative design with technical excellence to build brands that stand out. Experts in SEO, SMM, and Web Development.",
			url: "/about",
			keywords: [
				"about CraftLayer",
				"digital agency bangalore",
				"web design team",
				"marketing experts bangalore",
				"brand story",
			],
		}),
});
